<template>
  <base-modal
    hookSufix="VideosFilterModal"
    content-class="videos-filter-modal"
    :modalWidth="'798px'"
    :minHeight="'unset'"
    :persistent="false"
    :hideCloseBtn="true"
    :disableDefaultPadding="true"
    :onCloseHook="onClose"
    :onOpenHook="onOpen"
  >
    <template #content>
      <v-row class="modal-content--header" no-gutters>
        <div class="d-flex flex-column">
          <template v-if="isComparisonPage">
            <span class="modal-content--title body-bold-large">{{
              $t('message.pages.analyticsV3.videosFilter.modal.comparisonTitle')
            }}</span>
            <span class="modal-content--subtitle body-regular-smaller">{{
              $t(
                'message.pages.analyticsV3.videosFilter.modal.comparisonSubtitle'
              )
            }}</span>
          </template>
          <template v-else>
            <span class="modal-content--title body-bold-large">{{
              $t('message.pages.analyticsV3.videosFilter.modal.title')
            }}</span>
            <span class="modal-content--subtitle body-regular-smaller">{{
              $t('message.pages.analyticsV3.videosFilter.modal.subtitle')
            }}</span>
          </template>
        </div>
        <v-spacer></v-spacer>
        <v-icon class="modal-content--close-btn" @click="closeModal"
          >panda-close</v-icon
        >
      </v-row>
      <v-divider></v-divider>

      <videos-filter-table
        :dialog-visible="dialogVisible"
        @selectedVideosToAnalyze="(val) => (selectedVideosToAnalyze = val)"
        @allAccountVideos="(val) => (allAccountVideos = val)"
        @emptyFolderSelected="(val) => (emptyFolderSelected = val)"
      ></videos-filter-table>
      <div class="modal-content--footer">
        <portal-target name="filter-footer"></portal-target>
        <portal :to="isComparisonPage ? 'comparison-footer' : 'filter-footer'">
          <v-tooltip bottom :disabled="!compareVideosDisabled">
            <template v-slot:activator="{ on, attrs }">
              <base-btn
                v-on="on"
                v-bind="attrs"
                :disabled="compareVideosDisabled"
                @click="handleCompareVideos"
                :type="isComparisonPage ? 'primary' : 'secondary'"
                >{{
                  $t(
                    'message.pages.analyticsV3.videosFilter.modal.actions.compareVideos'
                  )
                }}</base-btn
              >
            </template>
            <span>{{
              $t(
                'message.pages.analyticsV3.videosFilter.modal.actions.compareTooltip'
              )
            }}</span>
          </v-tooltip>
        </portal>
        <v-spacer></v-spacer>
        <div class="body-regular-smaller selection-count">
          {{ filterSelectionCountStatus }}
        </div>
        <template v-if="isComparisonPage">
          <portal-target name="comparison-footer"></portal-target>
        </template>
        <template v-else>
          <base-btn
            v-if="selectedVideosToAnalyze.length"
            type="primary"
            @click="handleFilter"
            >{{
              $t(
                'message.pages.analyticsV3.videosFilter.modal.actions.filterSelectedVideos'
              )
            }}</base-btn
          >
          <base-btn
            v-else
            type="primary"
            @click="handleFilter"
            :disabled="emptyFolderSelected"
            >{{
              $t(
                'message.pages.analyticsV3.videosFilter.modal.actions.filterAllVideos'
              )
            }}</base-btn
          >
        </template>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue'
import BaseBtn from '@/components/BaseBtn.vue'
import VideosFilterTable from './VideosFilterTable.vue'
import { mapMutations, mapState } from 'vuex'
import videosApi from '@/services/videosApi'
export default {
  name: 'VideosFilterModal',
  components: {
    BaseModal,
    BaseBtn,
    VideosFilterTable,
  },
  data() {
    return {
      dialogVisible: false,
      selectedVideosToAnalyze: [],
      allAccountVideos: [],
      emptyFolderSelected: false,
    }
  },
  watch: {
    '$i18next.resolvedLanguage': {
      handler() {
        this.$emit('appliedFilterText', this.filterSelectionCountStatus)
      },
    },
  },
  computed: {
    ...mapState({
      filterVideos: (state) => state.analytics.filters.filterVideos,
      compareVideos: (state) => state.analytics.filters.compareVideos,
      selectedVideosToComparison: (state) =>
        state.analytics.filters.compareVideos.selectedVideos,
    }),
    hasVideoFilterApplied() {
      return !!this.selectedVideosToComparison?.length
    },
    isComparisonPage() {
      return this.$route.name === 'AnalyticsV3VideoComparer'
    },
    compareVideosDisabled() {
      return (
        this.selectedVideosToAnalyze.length > 3 ||
        this.selectedVideosToAnalyze.length < 2
      )
    },
    filterSelectionCountStatus() {
      if (this.selectedVideosToAnalyze.length > 0)
        return this.$t(
          'message.pages.analyticsV3.videosFilter.modal.filterSelectionCount',
          {
            selectionCount: this.selectedVideosToAnalyze.length,
            isPlural: this.selectedVideosToAnalyze.length > 1 ? 's' : '',
          }
        )
      return this.$t(
        'message.pages.analyticsV3.videosFilter.modal.noFilterSelectionCount'
      )
    },
  },
  methods: {
    ...mapMutations('analytics', [
      'UPDATE_FILTER_VIDEOS',
      'UPDATE_COMPARE_VIDEOS',
    ]),
    confirm() {
      //   this.$emit('confirmed')
      //   this.$root.$emit('closeEnable2FAModal')
    },
    onClose() {
      this.dialogVisible = false
    },
    onOpen() {
      this.dialogVisible = true
    },
    closeModal() {
      this.$root.$emit('closeVideosFilterModal')
    },
    handleFilter() {
      let videosIdsToFilter
      if (this.selectedVideosToAnalyze.length) {
        videosIdsToFilter = this.mapVideosToFilter(this.selectedVideosToAnalyze)
        this.$emit('filterAll', false)
      } else {
        videosIdsToFilter = []
        this.$emit('filterAll', true)
      }
      this.UPDATE_FILTER_VIDEOS({ selectedVideos: videosIdsToFilter })
      this.updateFilterPickerStatus()
      this.closeModal()
    },
    handleCompareVideos() {
      const videosIdsToCompare = this.mapVideosToCompare(
        this.selectedVideosToAnalyze
      )
      this.$emit('filterAll', false)
      this.UPDATE_COMPARE_VIDEOS({ selectedVideos: videosIdsToCompare })
      this.updateFilterPickerStatus()
      this.closeModal()
      if (this.isComparisonPage) {
        return this.$root.$emit('handleVideosNewComparison')
      } else {
        return this.$router.push({ name: 'AnalyticsV3VideoComparer' })
      }
    },
    updateFilterPickerStatus() {
      this.$emit('appliedFilterText', this.filterSelectionCountStatus)
      this.$emit('hasFilterApplied', true)
    },
    mapVideosToFilter(videosArray) {
      return videosArray.flatMap((video) => {
        return {
          videoId: video.id,
          title: video.title,
          videoExternalId: video.video_external_id,
        }
      })
    },
    mapVideosToCompare(videosArray) {
      return videosArray.flatMap((video) => {
        return {
          videoId: video.id,
          title: video.title,
          pullzone_name: video.pullzone_name,
          video_external_id: video.video_external_id,
        }
      })
    },
  },
  async mounted() {
    if (this.$route.query && this.$route.query.v) {
      const videoInfo = await videosApi.getAVideo(this.$route.query.v)
      this.selectedVideosToAnalyze = [videoInfo.data]
      this.handleFilter()
    }
  },
}
</script>

<style lang="scss" scoped>
.modal-content--header {
  padding: $spacing-05 $spacing-05;

  .modal-content--title {
    color: varFigma(neutral-20-dark);
    padding-left: $spacing-03;
  }

  .modal-content--subtitle {
    color: varFigma(neutral-30-base);
    padding-left: $spacing-03;
  }

  .modal-content--close-btn {
    width: 24px;
    height: 24px;
    align-items: flex-start;
    margin-right: $spacing-03;
    align-self: center;
    &.v-icon.v-icon::after {
      background-color: transparent;
    }
  }
}

.modal-content--footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: $spacing-07;
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid varFigma(neutral-95-lightest);
  background-color: varFigma(neutral-99);

  .selection-count {
    color: varFigma(neutral-40-light);
    text-align: right;
    margin-right: $spacing-07;
  }
}
</style>
